import $ from "jquery";
import fallback from "./SMCOpenApiSuffix.json";

var api_route = { ...fallback };

var _ready = $
  .get({
    url: "https://server.dietz.asia/SMCOpenApiSuffix.php",
    dataType: "json",
  })
  .then((data) => {
    Object.assign(api_route, data);
    return api_route;
  })
  .catch(() => api_route);

export function openApiSuffixReady() {
  return _ready;
}

export default api_route;
